;

(function (GC) {
  var GCKissmetrics = function GCKissmetrics(analytics) {
    var analytics = analytics || {};
    var kissmetrics = {
      event: function event(_event) {
        var km = window._kmq || [];
        km.push(_event);
      }
    };
    return {
      kissmetrics: kissmetrics
    };
  };

  GC.queue = GC.queue || [];
  GC.queue.push({
    method: function method(mount, GCmodule) {
      this._loadModule(mount, GCmodule);
    },
    args: ['analytics', new GCKissmetrics()]
  });
  window.GC = GC;
})(window.GC || {});